import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import CardRequiredModel from '../model/CardRequiredModel';
import CardService from '../services/CardService';
class RequiredDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            element: new CardRequiredModel(),
            viewMode: this.props.viewMode,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setElement();
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container required-dialog-footer'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton
                    label={t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: CardRequiredModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    createOrUpdate() {
        const {element} = this.state;
        element.cards = this.props.cardNumbers;
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .updateRequired(element)
                .then((response) => {
                    //this.blockUi();
                    if (this.props.handleSuccess) {
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    this.unblockUi();
                    if (this.props.handleError) {
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <InputCheckboxComponent
                        id={'vehicleRequired-dialog'}
                        name='vehicleRequired'
                        label={t('cards.registrationNumberFull')}
                        labelOnRight
                        value={this.state.element.vehicleRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        disabled={this.props.cardKind === 'VEHICLE' || this.props.cardKind === 'VEHICLE_PERSON'}
                        colClass='col-width-auto'
                    />
                    <InputCheckboxComponent
                        id={'driverRequired-dialog'}
                        name='driverRequired'
                        label={t('cards.fullName')}
                        labelOnRight
                        value={this.state.element.driverRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                        disabled={this.props.cardKind === 'PERSON' || this.props.cardKind === 'VEHICLE_PERSON'}
                    />
                    <InputCheckboxComponent
                        id={'odometerRequired-dialog'}
                        name='odometerRequired'
                        label={t('cards.odometer')}
                        labelOnRight
                        value={this.state.element.odometerRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                    />
                    <InputCheckboxComponent
                        id={'mpkRequired-dialog'}
                        name='mpkRequired'
                        label={t('cards.mpk')}
                        labelOnRight
                        value={this.state.element.mpkRequired}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators='not_required'
                        colClass='col-width-auto'
                    />
                </div>
            </React.Fragment>
        );
    }
}

RequiredDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

RequiredDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    cardKind: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
};

export default withTranslation()(RequiredDialog);
